import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import auth from '@/middleware/auth'
import log from '@/middleware/log'

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/presupuestos/list',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        meta: {
          middleware: [auth, log],
        },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      {
        path: '/mantenedores',
        name: 'Mantenedores',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/mantenedores/area',
        meta: {
          middleware: [auth, log],
        },
        children: [
          // {
          //   path: '/mantenedores/clientes',
          //   name: 'Clientes',
          //   component: () => import('@/views/mantenedor/clientes.vue'),
          // },
          {
            path: '/mantenedores/area',
            name: 'Área',
            component: () => import('@/views/mantenedor/area.vue'),
          },
          {
            path: '/mantenedores/lineaGasto',
            name: 'Línea de gasto',
            component: () => import('@/views/mantenedor/lineaGasto.vue'),
          },
          {
            path: '/mantenedores/hito',
            name: 'Hitos',
            component: () => import('@/views/mantenedor/hito.vue'),
          },
          {
            path: '/mantenedores/tipoDocumento',
            name: 'Tipo documento',
            component: () => import('@/views/mantenedor/tipoDocumento.vue'),
          },
          {
            path: '/mantenedores/snc',
            name: 'SNC',
            component: () => import('@/views/mantenedor/snc.vue'),
          },
          // {
          //   path: '/mantenedores/costoEmpresa',
          //   name: 'Costo Empresa',
          //   component: () => import('@/views/mantenedor/costoEmpresa.vue'),
          // },
          // {
          //   path: '/mantenedores/costoExtra',
          //   name: 'Costo Extra',
          //   component: () => import('@/views/mantenedor/costoExtra.vue'),
          // },
        ],
      },
      {
        path: '/configuracion',
        name: 'Configuración',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/configuracion/tipoNotificacion',
        meta: {
          middleware: [auth, log],
        },
        children: [
          {
            path: '/configuracion/tipoNotificacion',
            name: 'Notificaciones',
            component: () => import('@/views/configuracion/tipoNotificacion.vue'),
          },
          {
            path: '/configuracion/mensajeria',
            name: 'Mensajeria',
            component: () => import('@/views/configuracion/mensajeria.vue'),
          },
        ],
      },
      {
        path: '/presupuestos',
        name: 'Presupuestos',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/presupuestos/list',
        meta: {
          middleware: [auth, log],
        },
        children: [
          {
            path: '/presupuestos/list',
            name: 'Listado',
            component: () => import('@/views/presupuesto/list.vue'),
          },
          {
            path: '/presupuestos/presupuesto',
            name: 'Nuevo presupuesto',
            component: () => import('@/views/presupuesto/presupuesto.vue'),
          },
          {
            path: '/presupuestos/resumen',
            name: 'Resumen',
            component: () => import('@/views/presupuesto/resumen.vue'),
          },
          {
            path: '/presupuestos/asignado',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            children: [
              {
                path: '',
                name: 'Asignación',
                component: () => import('@/views/presupuesto/asignado.vue'),
              },
              {
                path: 'gestion',
                name: 'Gestión de presupuesto',
                component: () => import('@/views/gasto/list.vue'),
              },
            ],
          },
        ],
      },

      {
        path: '/reporte',
        name: 'Reportes',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/reporte/dashboard',
        meta: {
          middleware: [auth, log],
        },
        children: [
          {
            path: '/reporte/dashboard',
            name: 'ReporteDashboard',
            component: () => import('@/views/reporte/presupuestos.vue'),
          },
          {
            path: '/reporte/gastos',
            name: 'Gastos',
            component: () => import('@/views/reporte/gastos.vue'),
          },
          {
            path: '/reporte/facturacion',
            name: 'Facturación',
            component: () => import('@/views/reporte/facturacion.vue'),
          },
        ],
      },
      {
        path: '/permisos',
        name: 'Permisos',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/permisos/usuarios',
        meta: {
          middleware: [auth, log],
        },
        children: [
          {
            path: '/permisos/usuarios',
            name: 'Usuarios',
            component: () => import('@/views/permisos/usuarios.vue'),
          },
          {
            path: '/permisos/perfil',
            name: 'Perfiles',
            component: () => import('@/views/permisos/perfil.vue'),
          },
        ],
      },
      {
        path: '/proyecto',
        name: 'Proyecto',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/proyecto/trato',
        meta: {
          middleware: [auth, log],
        },
        children: [
          {
            path: '/proyecto/trato',
            name: 'Trato',
            component: () => import('@/views/proyecto/trato.vue'),
          },
          {
            path: '/proyecto/gestion/:id?',
            name: 'Gestion',
            component: () => import('@/views/proyecto/gestion.vue'),
          },
          {
            path: '/proyecto/factura',
            name: 'Factura',
            component: () => import('@/views/proyecto/factura.vue'),
          },
        ],
      },
      // {
      //   path: '/cotizacion',
      //   name: 'Cotizacion',
      //   component: {
      //     render() {
      //       return h(resolveComponent('router-view'))
      //     },
      //   },
      //   redirect: '/cotizacion/listado',
      //   meta: {
      //     middleware: [auth, log],
      //   },
      //   children: [
      //     {
      //       path: '/cotizacion/listado',
      //       name: 'Cotizaciones',
      //       component: () => import('@/views/cotizacion/list.vue'),
      //     },
      //     {
      //       path: '/cotizacion/nueva/:id?',
      //       name: 'Cotización',
      //       component: () => import('@/views/cotizacion/cotizacion.vue'),
      //     },
      //     {
      //       path: '/cotizacion/perfilProfesional',
      //       name: 'Perfil Profesional',
      //       component: () => import('@/views/cotizacion/perfilProfesional.vue'),
      //     },
      //     {
      //       path: '/cotizacion/tareas',
      //       name: 'Tareas',
      //       component: () => import('@/views/cotizacion/tareas.vue'),
      //     },
      //     {
      //       path: '/cotizacion/cotizacionIA',
      //       name: 'Cotizacion IA',
      //       component: () => import('@/views/cotizacion/cotizacionIA.vue'),
      //     },
      //     {
      //       path: '/cotizacion/outsourcing/',
      //       name: 'Outsourcing',
      //       component: {
      //         render() {
      //           return h(resolveComponent('router-view'))
      //         },
      //       },
      //       redirect: '/cotizacion/outsourcing/list',
      //       children: [
      //         {
      //           path: '/cotizacion/outsourcing/list',
      //           name: 'Cotizaciones Outsourcing',
      //           component: () => import('@/views/cotizacion/listOutsourcing.vue'),
      //         },
      //         {
      //           path: '/cotizacion/outsourcing/nueva',
      //           name: 'Nueva Cotización Outsourcing',
      //           component: () => import('@/views/cotizacion/outsourcing.vue'),
      //         },
      //       ],
      //     },
      //   ],
      // },

      {
        path: '/cumplimiento',
        name: 'Cumplimiento',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/cumplimiento/noconformidades/list',
        meta: {
          middleware: [auth, log],
        },
        children: [
          {
            path: 'noconformidades',
            name: 'Salidas no conformes',
            component: {
              render() {
                return h(resolveComponent('router-view'))
              },
            },
            redirect: '/cumplimiento/noconformidades/list',
            children: [
              {
                path: 'list',
                name: '',
                component: () => import('@/views/cumplimiento/listnoconformidades.vue'),
              },
              {
                path: 'nueva',
                name: 'Nueva salida no conforme',
                component: () => import('@/views/cumplimiento/noconformidades.vue'),
              },
            ],
          },
        ],
      },
      {
        path: '/checklist',
        name: 'Monitor Comercial',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        meta: {
          middleware: [auth, log],
        },
        children: [
          {
            path: '',
            name: 'Oportunidades',
            component: () => import('@/views/checklist/checklist.vue'),
          },
          {
            path: 'dashboard',
            name: 'ChecklistDashboard',
            component: () => import('@/views/checklist/checklist.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/login',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: 'login/:showMsjInvalidToken?',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'recuperar',
        name: 'Recuperar',
        component: () => import('@/views/pages/Recuperar'),
      },
    ],
  },
  {
    path: '/tv/:id',
    name: 'TvDashboard',
    component: () => import('@/views/tv/TvDashboard'),
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/views/pages/NotFound') },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    // If parameters are passed (like a redirect route), redirect immediately.
    if (parameters.length) {
      context.next(...parameters)
    } else {
      // Otherwise, proceed to the subsequent middleware.
      const nextMiddleware = nextFactory(context, middleware, index + 1)
      subsequentMiddleware({ ...context, next: nextMiddleware })
    }
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

export default router
